import React, { useState, useEffect } from "react";
import {
	Link,
	matchPath,
	NavLink,
	useLocation,
	useNavigate,
} from "react-router-dom";
import useSidebarStore, {
	routesRequiringConfirmation,
} from "../../../zustand/stores/sidebar-store";
import { Accordion, AccordionTab } from "primereact/accordion";

const Sidebar = ({ className, title, items, setShow }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const activeAccordion = useSidebarStore((state) => state.activeAccordion);
	const setActiveAccordion = useSidebarStore(
		(state) => state.setActiveAccordion
	);

	const openChildAccordion = useSidebarStore(
		(state) => state.openChildAccordion
	);
	const setOpenChildAccordion = useSidebarStore(
		(state) => state.setOpenChildAccordion
	);

	const activeSubItem = useSidebarStore((state) => state.activeSubItem);
	const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);
	const setPendingNavigation = useSidebarStore(
		(state) => state.setPendingNavigation
	);
	const [openSidebar, setOpenSideBar] = useState(false);
	const [openParent, setOpenParent] = useState(false);

	// const [openChildAccordion, setOpenChildAccordion] = useState(null); // Track open state for child accordions

	// opening the accordion
	const toggleAccordion = (index) => {
		setOpenParent(true);

		if (index !== activeAccordion) {
			setOpenChildAccordion(null);
			setActiveSubItem(null);
		}

		setActiveAccordion(index === activeAccordion ? -1 : index);
	};
	// opening the child of the child
	const toggleChildAccordion = (parentIndex, childIndex, item) => {
		const identifier = `${parentIndex}-${childIndex}`;
		setActiveAccordion(parentIndex);
		if (openChildAccordion === identifier) {
			setOpenChildAccordion(null);
			setActiveSubItem(null);
		} else {
			setOpenChildAccordion(identifier);
			setActiveSubItem(item);
		}
	};

	useEffect(() => {
		if (openChildAccordion !== null) {
			const [parentIndex, childIndex] = openChildAccordion
				.split("-")
				.map(Number);

			setActiveAccordion(parentIndex);

			const parentItem = items[parentIndex];
			if (parentItem && parentItem.content) {
				const childItem = parentItem.content[childIndex];
				if (childItem) {
					setActiveSubItem(childItem);
				}
			}
		} else {
			const matchingAccordionIndex = items.findIndex((item) => {
				const isMainLinkMatch = Array.isArray(item.link)
					? item.link.some((link) => location.pathname.includes(link))
					: location.pathname.includes(item.link);

				if (isMainLinkMatch) {
					setActiveSubItem(item);
					return true;
				}

				return item.content?.some((subItem) => {
					const isSubLinkMatch = Array.isArray(subItem.link)
						? subItem.link.some((link) => location.pathname.includes(link))
						: location.pathname.includes(subItem.link);

					if (isSubLinkMatch) {
						setActiveSubItem(subItem);
					}

					return isSubLinkMatch;
				});
			});

			setActiveAccordion(matchingAccordionIndex);
		}
	}, [
		openChildAccordion,
		location.pathname,
		items,
		setActiveAccordion,
		setActiveSubItem,
	]);

	const handleItemClick = (link) => {
		const currentUrl = location.pathname;
		const isRouteRequiringConfirmation = (url) => {
			return routesRequiringConfirmation.some((route) => {
				const pattern = {
					path: route,
					end: false,
				};
				const match = matchPath(pattern, url); // Convert to boolean
				return !!match; // Convert match object to boolean
			});
		};

		if (isRouteRequiringConfirmation(currentUrl)) {
			setPendingNavigation(link);
		} else {
			navigate(link);
		}
	};
	const renderAccordionContent = (content, parentIndex) => {
		return content.map((item, index) => {
			const isActive = item.title === activeSubItem;

			const childIndex = `${parentIndex}-${index}`;
			return (
				<div key={index} className="pl-6">
					{item.type === "accordion" && (
						<button
							className="flex items-center justify-between w-full text-left px-4 py-2 text-lg font-medium focus:outline-none focus:shadow-outline-blue"
							onClick={() => toggleChildAccordion(parentIndex, index, item)} // Toggle child accordion and set active sub-item
						>
							{item.title}
							<svg
								className={`w-4 h-4 transition-transform transform ${
									activeAccordion &&
									activeSubItem &&
									activeSubItem.title === item.title
										? "rotate-180"
										: "rotate-0"
								}`}
								// className={`w-4 h-4 transition-transform transform ${
								// 	activeAccordion === index ? "rotate-180" : "rotate-0"
								// }`}
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M9 5l7 7-7 7"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</button>
					)}

					{item.type !== "accordion" && (
						// <NavLink
						// 	to={item.link}
						// 	className={({ isActive }) =>
						// 		isActive
						// 			? "block w-full px-4 py-2 text-lg font-medium rounded-md text-center bg-secondary-darkGray text-primary-primaryYellow"
						// 			: "text-lg block w-full px-4 py-2 font-medium rounded-md hover:bg-secondary-darkGray hover:text-primary-primaryYellow"
						// 	}
						// 	onClick={() => {
						// 		// console.log("NavLink");
						// 		// setOpenSideBar(false);
						// 		handleItemClick(item.link, item.title);
						// 	}}
						// >
						// 	{item.title}
						// </NavLink>

						<span
							// className={({ isActive }) =>
							// 	isActive
							// 		? "block w-full px-4 py-2 text-lg font-medium rounded-md text-center bg-secondary-darkGray text-primary-primaryYellow cursor-pointer"
							// 		: "text-lg block w-full px-4 py-2 font-medium rounded-md hover:bg-secondary-darkGray hover:text-primary-primaryYellow cursor-pointer"
							// }
							className={`p-2 normal-case cursor-pointer  hover:rounded-sm  ${
								activeSubItem?.title === item?.title ||
								location.pathname === item.link
									? "block w-full px-4 py-2 text-lg font-medium rounded-md text-center bg-secondary-darkGray text-primary-primaryYellow cursor-pointer"
									: "text-lg block w-full px-4 py-2 font-medium rounded-md hover:bg-secondary-darkGray hover:text-primary-primaryYellow cursor-pointer"
							}`}
							onClick={() => {
								// console.log("NavLink");
								setOpenSideBar(false);
								handleItemClick(item.link, item.title);
							}}
						>
							{item.title}
						</span>
					)}

					{item.type === "accordion" &&
						activeSubItem &&
						activeSubItem.title === item.title && (
							<div className="pl-4">
								{renderAccordionContent(item.content, childIndex)}{" "}
							</div>
						)}
				</div>
			);
		});
	};

	return (
		<div>
			<div
				className={`bg-primary-primaryYellow text-secondary-darkGray h-full p-4 overflow-y-auto ${className}`}
			>
				<div className="flex gap-2">
					<h2 className="text-xl font-semibold mb-4">{title}</h2>
					<i
						className="fas fa-close my-auto font-bold ml-auto mb-4 lg:hidden"
						onClick={() => setShow(false)} // Close the sidebar
					></i>
				</div>

				<div className="mb-4">
					{items.map((item, index) => (
						<div key={index}>
							{item.type === "accordion" && (
								<button
									className="flex items-center justify-between w-full text-left px-4 py-2 text-lg font-medium focus:outline-none focus:shadow-outline-blue"
									onClick={() => {
										toggleAccordion(index);
									}} // Top-level accordion toggle
								>
									{item.title}
									<svg
										className={`w-4 h-4 transition-transform transform ${
											activeAccordion === index ? "rotate-180" : "rotate-0"
										}`}
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M9 5l7 7-7 7"
											stroke="currentColor"
											strokeWidth="2"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</button>
							)}

							{item.type !== "accordion" && (
								<NavLink
									to={item.link}
									className="text-lg block w-full px-4 py-2 text-sm font-medium hover:bg-secondary-darkGray hover:text-primary-primaryYellow focus:outline-none focus:shadow-outline-blue"
								>
									{item.title}
								</NavLink>
							)}

							{item.type === "accordion" && activeAccordion === index && (
								<div className="p-2 pl-6">
									{renderAccordionContent(item.content, index)}{" "}
								</div>
							)}
						</div>
					))}
					{/* <Accordion activeIndex={activeAccordion}>
						{createDynamicTabs()}
					</Accordion> */}
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
